import { createSlice, PayloadAction, createSelector } from '@reduxjs/toolkit'
import { TagGroup } from '@/ts/interfaces/tags'
import { RootState } from '../index'

interface TagGroupsState {
  tagGroups: TagGroup[]
}

const initialState: TagGroupsState = {
  tagGroups: []
}

export const tagGroupsSlice = createSlice({
  name: 'tagGroups',
  initialState,
  reducers: {
    setTagGroups: (state, action: PayloadAction<TagGroup[]>) => {
      state.tagGroups = action.payload
    },
    addTagGroup: (state, action: PayloadAction<TagGroup>) => {
      state.tagGroups.push(action.payload)
    },
    updateTagGroup: (state, action: PayloadAction<TagGroup>) => {
      const index = state.tagGroups.findIndex((p) => p.id === action.payload.id)
      if (index !== -1) {
        state.tagGroups[index] = action.payload
      }
    },
    deleteTagGroup: (state, action: PayloadAction<number>) => {
      const index = state.tagGroups.findIndex((p) => p.id === action.payload)
      if (index !== -1) {
        state.tagGroups[index].deleted_at = new Date()
      }
    },
    clearTagGroups: (state) => {
      state.tagGroups = []
    }
  }
})

export const { setTagGroups, addTagGroup, updateTagGroup, deleteTagGroup, clearTagGroups } = tagGroupsSlice.actions

export const selectTagGroups = (state: RootState) => state.tagGroups.tagGroups
export const selectActiveTagGroups = createSelector([selectTagGroups], (tagGroups) => tagGroups.filter((p) => !p.deleted_at))

export default tagGroupsSlice.reducer
